/**
 * MeasurePanel — Measurement tools (distance / area / coordinates)
 * Auto-activates distance mode so map is ready when the panel opens.
 */
import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import MeasurementToolsPanel from '../../MeasurementToolsPanel';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { setMeasurementMode } from '../../../store/slices/measurementSlice';
import { setActiveTool as setDrawingTool } from '../../../store/slices/drawingSlice';
import { tokens } from '../../../theme';
import { useGeoveraTheme } from '../../../theme/ThemeContext';

const MeasurePanel: React.FC = () => {
  const dispatch = useAppDispatch();
  const { palette } = useGeoveraTheme();
  const activeMode = useAppSelector((s) => s.measurement.activeMode);

  useEffect(() => {
    // Avoid conflicting with draw tools
    dispatch(setDrawingTool(null));
    if (!activeMode) {
      dispatch(setMeasurementMode('distance'));
    }
    return () => {
      // leave mode active so user can finish on map; clear only if still measuring unused
    };
  }, [dispatch, activeMode]);

  return (
    <Box sx={{ p: 1 }}>
      <Typography
        sx={{
          fontSize: tokens.fontSize.sm,
          color: palette.text.secondary,
          px: 0.5,
          pb: 1,
          lineHeight: 1.45,
        }}
      >
        Click on the map to measure. Double-click to finish a distance or area.
      </Typography>
      <MeasurementToolsPanel />
    </Box>
  );
};

export default MeasurePanel;
